import { LIFEPOINT, EmboldClientIdentifier } from 'utils/constants';
import lifepointThemeVariant from './lifepointThemeVariant';
import testThemeVariant from './testThemeVariant';
import type { PartialThemeOverrides } from './themeVariants.types';

export const DEFAULT = 'default' as const;
export const TEST_VARIANT = 'test theme variant' as const;

type ThemeVariantContent = { name: string; spec: PartialThemeOverrides };
type ThemeVariantMap = {
  [DEFAULT]: ThemeVariantContent;
  [TEST_VARIANT]: ThemeVariantContent;
} & Partial<Record<EmboldClientIdentifier, ThemeVariantContent>>;
export type ThemeVariantMapKey = keyof ThemeVariantMap;

export const CLIENT_THEME_VARIANT_MAP: ThemeVariantMap = {
  [DEFAULT]: {
    name: DEFAULT,
    spec: {},
  },
  [TEST_VARIANT]: {
    name: TEST_VARIANT,
    spec: testThemeVariant,
  },

  [LIFEPOINT]: {
    name: 'lifepoint',
    spec: lifepointThemeVariant,
  },
};
